import { useEffect, useState } from 'react'

// A phone can be wider than 767 CSS pixels after rotation. Keep the same
// cabinet on touch phones in landscape, while a narrow desktop window still
// follows its viewport width as before.
export const MOBILE_WEB_QUERY = '(max-width: 767px), (pointer: coarse) and (orientation: landscape) and (max-height: 767px)'

function getMatches() {
  return typeof window !== 'undefined' && window.matchMedia(MOBILE_WEB_QUERY).matches
}

export function useMobileViewport() {
  const [isMobile, setIsMobile] = useState(getMatches)

  useEffect(() => {
    const media = window.matchMedia(MOBILE_WEB_QUERY)
    const handleChange = (event: MediaQueryListEvent) => setIsMobile(event.matches)

    setIsMobile(media.matches)
    media.addEventListener('change', handleChange)
    return () => media.removeEventListener('change', handleChange)
  }, [])

  return isMobile
}
